module.exports = __webpack_public_path__ + "static/media/6.7ef9d2ba.svg";